export const serverUrl = 'https://opd-api.amddentalclinic.com'
// export const serverUrl = 'http://localhost:5001'
export const primaryColor = '#f8bbd0'
export const secondaryColor = '#ecfce4'
export const primaryDark = '#ec407a'
